import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, addOnInvalidateHandler, invalidateResource } from "kea-resource";
import { ResourceIdentificacionRepetido, CampoRepetidoIdentificacion } from "./identificacion";
import { Cliente } from "./cliente";

const controller = rpcController("ContactoCliente");

export interface ContactoClienteRepetidoDatos {
    idContacto: number | null;
    idDireccion: number;
}
export const ContactoCliente = cacheResource({
    RepetidoIdentificacion: async (valor: string, campo: CampoRepetidoIdentificacion, datos: ContactoClienteRepetidoDatos) => await controller("Repetido" + campo, { ...datos, valor: valor }),

    /**
      * Obtiene un contacto de un cliente
      * @param idContacto Id del contacto
      * @returns  El contacto
      */
    Get: async (idContacto: number): Promise<models.ContactoClienteDTO> => await controller("Get", { idContacto }),

    /**
     * Actualiza un contacto
     * @param entity 
     */
    Update: async (entity: models.ContactoCliente): Promise<void> => await controller("Update", {}, entity),

    /**
     * Elimina un contacto
     * @param id 
     */
    Delete: async (id: number): Promise<void> => await controller("Delete", { id }),

    /**
         * Agrega un contacto cliente
         * @param entity 
         */
    Add: async (entity: models.ContactoCliente): Promise<number> => await controller("Add", {}, entity),

}, {
        RepetidoIdentificacion: true,
        Get: true
    }, {
        Delete: true,
        Update: true,
        Add: true
    });

const test: ResourceIdentificacionRepetido<ContactoClienteRepetidoDatos> = ContactoCliente;

//Cuando cambien los clientes refrescamos el ContactoCliente,
//tambien cuando cambie ContactoCliente refrescamos al cliente
addOnInvalidateHandler(Cliente, () => invalidateResource(ContactoCliente));
addOnInvalidateHandler(ContactoCliente, () => invalidateResource(Cliente));


// WEBPACK FOOTER //
// ./app/resources/items/contactocliente.ts